<template>
  <div>

    <!-- Floating Button -->
    <floating-button @click="save()" save v-if="isEditing"/>

    <v-card :loading="isLoadingData && !authUser">
      <v-card-title primary-title>
        <v-btn small color="primary" class="mr-4" @click="clickBack()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        Daño <span v-if="!isLoadingData">&nbsp;{{ isNew ? bladeDamages.length + 1 : currentDamage }}</span>
      </v-card-title>
      <v-card-text v-if="authUser">
        <v-container>
          <v-stepper v-model="step" vertical class="pa-0 elevation-0">

            <!-- Basic Data -->
            <v-stepper-step :step="1" :editable="!isNew">Datos basicos</v-stepper-step>
            <v-stepper-content :step="1">
              <v-form ref="form">
                <v-row align="start" justify="space-around">
                  <!-- AG / Blade -->
                  <v-col cols="12">
                    <v-row class="px-3">
                      <v-col cols="12" class="grey lighten-4 round-corners">
                        <span class="font-weight-bold mr-4">Datos generales</span>
                      </v-col>
                      <!-- AG Number -->
                      <v-col cols="2">
                        <v-text-field
                          label="Número AG"
                          v-model="item.wind_turbine"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                        ></v-text-field>
                      </v-col>
                      <!-- AG Model -->
                      <v-col cols="4">
                        <v-autocomplete
                          v-model.number="item.wind_turbine_type_id"
                          :items="turbineList"
                          label="Modelo AG"
                          :item-text="text"
                          item-value="id"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                          chips
                          small-chips
                          deletable-chips
                        ></v-autocomplete>
                      </v-col>
                      <!-- Blade Number -->
                      <v-col cols="2">
                        <v-text-field
                          label="Número pala"
                          v-model.number="item.blade"
                          type="number"
                          :readonly="!isEditing"
                          :rules="bladeRules"
                          required
                        ></v-text-field>
                      </v-col>
                      <!-- Blade Model -->
                      <v-col cols="4">
                        <v-autocomplete
                          v-model.number="item.wind_turbine_blade_type_id"
                          :items="bladeList"
                          label="Modelo pala"
                          item-value="id"
                          :item-text="text"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                          chips
                          small-chips
                          deletable-chips
                        ></v-autocomplete>
                      </v-col>
                      <!-- Blade Serial -->
                      <v-col cols="4">
                        <v-text-field
                          label="Número de serie pala"
                          v-model="item.blade_serial_number"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                        ></v-text-field>
                      </v-col>
                      <!-- Size -->
                      <v-col cols="4">
                        <v-text-field
                          label="Tamaño"
                          v-model.number="item.size"
                          type="number"
                          suffix="cm"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                        ></v-text-field>
                      </v-col>
                      <!-- Damage Code -->
                      <v-col cols="4">
                        <v-select
                          label="Código del daño"
                          v-model.number="item.blade_damage_type_id"
                          :items="bladeDamageTypes"
                          item-text="name"
                          item-value="id"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                        ></v-select>
                      </v-col>
                      <!-- Damage Degree -->
                      <v-col cols="4">
                        <v-select
                          v-model="item.severity"
                          :items="damageDegree"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                          label="Grado del daño"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- Damage Location -->
                  <v-col cols="12">
                    <v-row class="px-3" justify="space-around">
                      <v-col cols="12" class="grey lighten-4 round-corners">
                        <span class="font-weight-bold mr-4">Úbicacion del daño </span>
                      </v-col>
                      <!-- Locations -->
                      <v-col cols="3">
                        <v-select
                          :items="damageLocations"
                          v-model="item.location"
                          :readonly="!isEditing"
                          label="Posición"
                          :rules="rules"
                          required
                          @change="checkLocation()"
                        ></v-select>
                      </v-col>
                      <!-- Radius -->
                      <v-col cols="3">
                        <v-text-field
                          label="Radio"
                          v-model.number="item.radius"
                          type="number"
                          suffix="cm"
                          :readonly="!isEditing"
                          :rules="rules"
                          required
                        ></v-text-field>
                      </v-col>
                      <!-- Distance B.A -->
                      <v-col cols="3">
                        <v-text-field
                          label="Dist. al borde de ataque"
                          v-model.number="item.ba_distance"
                          type="number"
                          suffix="cm"
                          :readonly="!isEditing"
                          :disabled="damageLocationBABS"
                          :rules="!damageLocationBABS ? rules : []"
                          :required="!damageLocationBABS"
                        ></v-text-field>
                      </v-col>
                      <!-- Distance B.S -->
                      <v-col cols="3">
                        <v-text-field
                          label="Dist. al borde de salida"
                          v-model.number="item.bs_distance"
                          type="number"
                          suffix="cm"
                          :readonly="!isEditing"
                          :disabled="damageLocationBABS"
                          :rules="!damageLocationBABS ? rules : []"
                          :required="!damageLocationBABS"
                        ></v-text-field>
                      </v-col>
                      <!-- Observations -->
                      <v-col cols="12">
                        <v-textarea
                          v-model="item.comments"
                          :readonly="!isEditing"
                          label="Observaciones"
                          auto-grow
                          :rules="rules"
                          required
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Data -->
            <v-stepper-step :step="2" :editable="!isNew">Datos</v-stepper-step>
            <v-stepper-content :step="2">
              <v-row align="start" justify="space-around">
                <!-- Image Damage Zone -->
                <v-col cols="10">
                  <blade-damage-vp
                    v-if="item.id"
                    :blade_damage_id="item.id"
                    :isEditing="isEditing"
                    @init="getBladeZones()"
                    :key="component"
                  />
                </v-col>
                <v-col cols="10">                           
                  <division />
                </v-col>
                <v-col cols="10">
                  <blade-damage-vs
                    v-if="item.id"
                    :blade_damage_id="item.id"
                    :isEditing="isEditing"
                    @init="getBladeZones()"
                    :key="component"
                  />
                </v-col>
                <!-- Repair Stages -->
                <v-col cols="12" v-if="work_type === reparacion">
                  <Repair-stages
                    :isEditing="isEditing"
                    :blade_damage_id="item.id"
                    :items="repairStageList"
                    :key="component"
                    @save="saveRepairStage($event)"
                    @delete="deleteRepairStage($event)"/>
                </v-col>
                <!-- Images Before Repair -->
                <v-col cols="6" v-if="work_type === reparacion">
                  <images-before-Repair
                    title="Imágen antes de la reparación"
                    :items="bladeDamagesImageBefore"
                    :isEditing="isEditing"
                    :key="component"
                    @save="uploadFile($event, 'before')"
                    @delete="deleteFile($event, 'before')"
                    />
                </v-col>
                <!-- Images After Repair -->
                <v-col cols="6" v-if="work_type === reparacion">
                  <images-after-Repair
                    title="Imágen después de la reparación"
                    :items="bladeDamagesImageAfter"
                    :isEditing="isEditing"
                    :key="component"
                    @save="uploadFile($event, 'after')"
                    @delete="deleteFile($event, 'after')"/>
                </v-col>
                <!-- Images Inspection -->
                <v-col cols="12" v-if="work_type === inspeccion">
                  <images-inspection
                    title="Imágenes"
                    :items="bladeDamagesImage"
                    :isEditing="isEditing"
                    :key="component"
                    @save="uploadFile($event, 'inspection')"
                    @delete="deleteFile($event, 'inspection')"/>
                </v-col>
                <!-- Materials Used -->
                <v-col cols="6" v-if="work_type === reparacion">
                  <materials-used
                    :isEditing="isEditing"
                    :items="usedMaterials"
                    :headers="materialsHeaders"
                    :options="materialTypes"
                    title="Materiales utilizados"
                    titleDialog="material utilizado"
                    labelOptions="Tipo de material"
                    :key="component"
                    @save="saveMaterial($event)"
                    @delete="deleteMaterial($event)"/>
                </v-col>
                <!-- Spare Part Used -->
                <v-col cols="6" v-if="work_type === reparacion">
                  <spare-parts-used
                    :isEditing="isEditing"
                    :items="usedSpareParts"
                    :headers="sparePartsHeaders"
                    :options="sparePartTypes"
                    title="Repuestos utilizados"
                    titleDialog="repuesto utilizado"
                    labelOptions="Tipo de repuesto"
                    :key="component"
                    @save="saveSparePart($event)"
                    @delete="deleteSparePart($event)"/>
                </v-col>
              </v-row>
            </v-stepper-content>

          </v-stepper>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FloatingButton from "@/components/FloatingButton";
import STATES from '@/models/States'
import MaterialsUsed from '@/components/InterventionReview/SelectAndNumber'
import SparePartsUsed from '@/components/InterventionReview/SelectAndNumber'
import ImagesBeforeRepair from '@/components/ImageUpload'
import ImagesAfterRepair from '@/components/ImageUpload'
import ImagesInspection from '@/components/ImageUpload'
import RepairStages from "./RepairStages";
import BladeDamageVP from "./BladeDamage/VP";
import BladeDamageVS from "./BladeDamage/VS";
import Division from "./BladeDamage/Division";
import Util from "@/util/index";

export default {
  props: {
    work_type: [String, Number],
    isEditing: { type: Boolean, default: false },
    damage: { type: Object, default: () => {} },
  },
  components: {
    FloatingButton,
    MaterialsUsed,
    SparePartsUsed,
    ImagesBeforeRepair,
    ImagesAfterRepair,
    ImagesInspection,
    RepairStages,
    'blade-damage-vp': BladeDamageVP,
    'blade-damage-vs': BladeDamageVS,
    Division
  },
  data: () => ({
    // TESTING -------------------------------------------------------->
    fileHeaders: [
      { text: "Nombre", value: "name", align: "center" },
      { text: "Acción", value: "action", sortable: false, align: "center" }
    ],
    imagesInspection: [],
    // TESTING -------------------------------------------------------->
    step: 1,
    component: 0,
    authUser: false,
    isLoadingData: false,
    isLoadingFiles: false,
    inspeccion: STATES.WORK_ORDER_TYPE_INSPECCION,
    reparacion: STATES.WORK_ORDER_TYPE_REPARACION,
    rules: [v => !!v || 'Obligatorio.'],
    rulesMultiple: [v => !!v && v.length > 0 || 'Obligatorio.'],
    bladeRules: [
      v => !!v || 'Obligatorio.',
      v => v > 0 && v <= 3 || 'Debe ser 1, 2 o 3.'
    ],
    // Damage
    item: {},
    damageIndex: -1,
    damageDialog: false,
    location: STATES.INTERVENTION_REVIEW_DAMAGE_LOCATION,
    damageLocations: STATES.INTERVENTION_REVIEW_DAMAGE_LOCATIONS,
    damageDegree: STATES.INTERVENTION_REVIEW_DAMAGE_DEGREE,
    image_upload: null,
    before_image_upload: null,
    after_image_upload: null,
    // Repair Stage
    repairStageList: [],
    // Material
    materialsList: [],
    materialsHeaders: [
      { text: "Material ", value: "material_type.name", align: "center" },
      { text: "Cantidad", value: "quantity", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
    // Spare Part
    sparePartsList: [],
    sparePartsHeaders: [
      { text: "Repuesto", value: "spare_part_type.name", align: "center" },
      { text: "Cantidad", value: "quantity", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
  }),
  watch: {
    damage() {
      this.init()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return !this.item.id
    },
    title () {
      return this.isNew ? 'Modificar' : 'Añadir'
    },
    bladeDamages () {
      return this.$store.state.interventions.bladeDamages.list
    },
    currentDamage() {
      let idx = 0
      for (let i=0; i < this.bladeDamages.length; i++) {
        const damage = this.bladeDamages[i]
        if (damage.id === this.item.id) {
          idx = i
          break;
        }
      }
      return idx + 1
    },
    damageLocationBABS() {
      return this.item.location === this.location.BA || this.item.location === this.location.BS
    },
    filteredFileHeaders () {
      return this.fileHeaders.filter(element => {
        if (this.isEditing && element.value === 'action') {
          return element
        } else if (element.value !== 'action') {
          return element
        }
      })
    },
    materialTypes () {
      return this.$store.state.interventions.options.materialTypes
    },
    sparePartTypes () {
      return this.$store.state.interventions.options.sparePartTypes
    },
    bladeDamageTypes () {
      return this.$store.state.interventions.options.bladeDamageTypes
    },
    turbineList () {
      return this.$store.state.interventions.item.wind_farm && this.$store.state.interventions.item.wind_farm.wind_turbine_types
    },
    bladeList () {
      return this.$store.state.interventions.item.wind_farm && this.$store.state.interventions.item.wind_farm.wind_turbine_blade_types
    },
    bladeDamagesImage () {
      return this.$store.state.interventions.bladeDamages.images
        .filter(element => element.type !== 'before' && element.type !== 'after')
    },
    bladeDamagesImageBefore () {
      return this.$store.state.interventions.bladeDamages.images
        .filter(element => element.type === 'before')
    },
    bladeDamagesImageAfter () {
      return this.$store.state.interventions.bladeDamages.images
        .filter(element => element.type === 'after')
    },
    usedMaterials () {
      return this.$store.state.interventions.usedMaterials.list
    },
    usedSpareParts () {
      return this.$store.state.interventions.usedSpareParts.list
    },
  },
  methods: {
    text (item) {
      return item.manufacturer + ' - ' + item.model
    },
    clickBack () {
      this.$emit('init')
      this.$emit('clickBack')
    },
    errorAlert (error, altText) {
      if (error.response.status === 403 ) {
        this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
          color: "error",
          x: "center",
          y: "top",
          icon: "mdi-information",
          timeout: 0,
          showClose: true,
          closeText: "Cerrar"
        });
        this.$router.push({ name: 'home'})
      } else {
        let errorToastMessage = `Ha ocurrido un error ${altText}`
        Util.showErrorToast(this, error, errorToastMessage);
      }
    },
    checkLocation() {
      if (this.damageLocationBABS) {
        this.item.ba_distance = 0
        this.item.bs_distance = 0
      }
    },
    save () {
      if (this.$refs.form.validate()) this.isNew ? this.create() : this.edit()
    },
    create () {
      this.loading = true
      const body = {
        ...this.item,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
      }
      this.$store.dispatch('interventions/bladeDamages/create', body)
        .then(async response => {
          const data = response.data.data
          console.log("create -> id", data.id)
          await this.init(data.id)
          this.$toast("Daño guardado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.component++
        })
        .catch(error => {
          var errorToastMessage = "guardando el daño."
          this.errorAlert(error, errorToastMessage)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit () {
      this.loading = true
      const body = {
        ...this.item,
        work_order_id: this.$route.params.work_order,
      }
      this.$store.dispatch('interventions/bladeDamages/edit', body)
        .then(() => {
          this.$toast("Daño guardado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.$emit('init')
          this.clickBack()
        })
        .catch(error => {
          var errorToastMessage = "guardando el daño."
          this.errorAlert(error, errorToastMessage)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Blade Damage Types
    async getBladeDamageTypes () {
      this.isLoadingData = true
      await this.$store.dispatch('interventions/options/getBladeDamageTypes')
        .catch(error => {
          const altText = "la lista de códigos de daño"
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.isLoadingData = false
        })
    },
    // Material
    async getMaterials (init) {
      if (!this.isNew) {
        this.isLoadingData = true
        const body = {
          id: this.item.id || this.damage.id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'usedMaterial'
        }
        await this.$store.dispatch('interventions/usedMaterials/list', body)
          .catch(error => {
            let altText = "cargando lista de materiales"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      if (init) {
        this.isLoadingData = true
        await this.$store.dispatch('interventions/options/getMaterialTypes')
          .catch(error => {
            const altText = "cargando la lista de tipos de materiales"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
    },
    saveMaterial (params) {
      this.loading = true
      const item = {
        blade_damage_id: params.blade_damage_id || this.item.id,
        material_type_id: params.option,
        quantity: params.quantity
      }
      if (params.id) {
        item.id = params.id
        this.$store.dispatch('interventions/usedMaterials/edit', item)
          .then(() => {
            this.$toast("Material modificado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getMaterials()
          })
          .catch(error => {
            let altText = "modificando el material."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('interventions/usedMaterials/create', item)
          .then(() => {
            this.$toast("Material creado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getMaterials()
          })
          .catch(error => {
            let altText = "creando el material."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    deleteMaterial (item) {
      this.loading = true
      this.$store.dispatch('interventions/usedMaterials/delete', item.id)
        .then(() => {
          this.$toast("Material eliminado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.getMaterials()
        })
        .catch(error => {
          let altText = "eliminando el material."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Spare Part
    async getSpareParts (init) {
      if (!this.isNew) {
        this.isLoadingData = true
        const body = {
          id: this.item.id || this.damage.id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'usedSparePart'
        }
        await this.$store.dispatch('interventions/usedSpareParts/list', body)
          .catch(error => {
            let altText = "cargando lista de repuestos"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      if (init) {
        this.isLoadingData = true
        await this.$store.dispatch('interventions/options/getSparePartTypes')
          .catch(error => {
            const altText = "cargando la lista de tipos de repuestos"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
    },
    saveSparePart (params) {
      this.loading = true
      const item = {
        blade_damage_id: params.blade_damage_id || this.item.id,
        spare_part_type_id: params.option,
        quantity: params.quantity
      }
      if (params.id) {
        item.id = params.id
        this.$store.dispatch('interventions/usedSpareParts/edit', item)
          .then(() => {
            this.$toast("Repuesto modificado correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getSpareParts()
          })
          .catch(error => {
            let altText = "modificando el repuesto."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('interventions/usedSpareParts/create', item)
          .then(() => {
            this.$toast("Repuesto creando correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.getSpareParts()
          })
          .catch(error => {
            let altText = "creando el repuesto."
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    deleteSparePart (item) {
      this.loading = true
      this.$store.dispatch('interventions/usedSpareParts/delete', item.id)
        .then(() => {
          this.$toast("Repuesto eliminado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.getSpareParts()
        })
        .catch(error => {
          let altText = "eliminando el repuesto."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Damage Images
    async getBladeDamagesImage (id) {
      if (id) {
        this.isLoadingData = true
        const body = {
          id: id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'damageImages'
        }
        await this.$store.dispatch('interventions/bladeDamages/images', body)
          .catch(error => {
            let altText = "cargando lista de imágenes"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
    },
    uploadFile (file, type) {
      this.loading = true
      const upload = {
        id: this.item.id,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
        fileToUpload: file
      }
      if (type) upload.type = type
      this.$store.dispatch('interventions/bladeDamages/uploadFile', upload)
        .then(() => {
          this.$toast("Archivo subido correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.file = null
          this.getBladeDamagesImage(this.item.id)
        })
        .catch(error => {
          var errorToastMessage = "subiendo el archivo."
          this.errorAlert(error, errorToastMessage)
        })
        .finally(() => {
          this.loading = false
          this.$store.commit('uploading', null)
        })
    },
    deleteFile (file) {
      this.loading = true
      const body = {
        ...file,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
      }
      this.$store.dispatch('interventions/bladeDamages/deleteFile', body)
        .then(() => {
          this.$toast("Imágen borrada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.getBladeDamagesImage(this.item.id)
        })
        .catch(error => {
          var errorToastMessage = "borrando la imágen."
          this.errorAlert(error, errorToastMessage)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Get Blade Damages
    async getBladeZones(damage_id) {
      this.isLoadingData = true
      const id = damage_id || this.item.id
      const body = {
        id: id,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
        with: 'bladeDamageIsInBladeZone'
      }
      await this.$store.dispatch('interventions/bladeDamageIsInBladeZones/list', body)
        .then(() => {
          this.component++
        })
        .catch(error => {
          let altText = "cargando las zonas con daños"
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.isLoadingData = false
        })
      if (damage_id) {
        this.isLoadingData = true
        await this.$store.dispatch('interventions/bladeZones/list')
          .finally(() => {
            this.isLoadingData = false
          })
      }
    },
    // Init
    init (damage_id) {
      const id = damage_id || this.damage.id
      const body = {
        id: id,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
      }
      if (id) {
        this.isLoadingData = true
        this.$store.dispatch('interventions/bladeDamages/get', body)
          .then(async res => {
            this.item = res.data.data
            await this.getMaterials(true)
            await this.getSpareParts(true)
            await this.getBladeZones(id)
            await this.getBladeDamagesImage(id)
            if (damage_id) this.step++
            this.component++
            this.authUser = true
          })
          .catch(error => {
            const altText = "el daño"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
      else this.authUser = true
    }
  },
  async created () {
    await this.getBladeDamageTypes()
    this.init()
  }
}
</script>